export class TimeSyncDefinition {
    syncArrivalDate: boolean;
    syncProcessingEnd: boolean;
    syncStatusWaiting: boolean;
    syncStatusProcessing: boolean;
    syncStatusPaused: boolean;
    syncStatusCancelled: boolean;
    syncStatusFinished: boolean;

    constructor(definition: Partial<TimeSyncDefinition>) {
        this.syncArrivalDate = definition.syncArrivalDate;
        this.syncProcessingEnd = definition.syncProcessingEnd;
        this.syncStatusWaiting = definition.syncStatusWaiting;
        this.syncStatusProcessing = definition.syncStatusProcessing;
        this.syncStatusPaused = definition.syncStatusPaused;
        this.syncStatusCancelled = definition.syncStatusCancelled;
        this.syncStatusFinished = definition.syncStatusFinished;
    }
}